import React from 'react';
import { FaEdit } from 'react-icons/fa';

function TableRow({year, make, model, className, owner, isPaid, phone, onEdit, place, num, ballots, toggleCheckbox, parkingZone, isSelected}) {
  const color = () => {
    switch (ballots) {
      case undefined:
        return "Table bg-slate-200";
      case '-':
        return "Table bg-slate-200";
      case '1':
        return "Table bg-lime-300";
      default:
        return "Table bg-green-500";
    }

  }
  return (
    <tr>

      {toggleCheckbox ? <td className={color()}><input type="checkbox" checked={isSelected || false} onChange={toggleCheckbox}/></td> : null}
      {place ? <td className={color()}>{place}</td> : null}
      <td className={color()}>{num}</td>
      <td className={color()}>{year}</td>
      <td className={color()}>{make+ " " +model}</td>
      <td className={color()}>{className}</td>
      <td className={color()}>{owner}</td>
      <td className={color()}>{isPaid}</td>
      {ballots ? <td className={color()}>{ballots}</td> : null}
      {parkingZone ? <td className={color()}>{parkingZone}</td> : null}
      <td className={color()}>{phone}</td>
      <td className={color()}>
        <button onClick={onEdit} className='flex text-md gap-2'>
          Edit <FaEdit className='pt-1' />
        </button>
      </td>
    </tr>
  );
}

export default TableRow;
